import React, { useEffect, useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	Typography,
	Box,
	Chip
} from "@mui/material";

import { HTTP_ERROR_EVENT } from "@auto/events/Gui";

const statusLabel = (status) => {
	if (status === 400) return "Bad request";
	if (status === 401) return "Unauthorized";
	if (status === 403) return "Forbidden";
	if (status === 404) return "Not found";
	if (status === 409) return "Conflict";
	if (status === 500) return "Server error";
	if (status === 502) return "Bad gateway";
	if (status === 503) return "Service unavailable";
	if (status === 504) return "Gateway timeout";
	return "Request failed";
};

export const HttpErrorDialog = () => {
	const [error, setError] = useState(null);

	useEffect(() => {
		const listener = (event) => {
			console.error("HTTP error", event);
			setError(event);
		};

		HTTP_ERROR_EVENT.subscribe(listener);

		return () => {
			HTTP_ERROR_EVENT.unsubscribe(listener);
		};
	}, []);

	const goHome = () => {
		setError(null);
		window.location.href = "/";
	};

	return (
		<Dialog
			open={!!error}
			onClose={goHome}
			hideBackdrop
			maxWidth="xs"
			fullWidth
			sx={{
				zIndex: 2147483647
			}}
			PaperProps={{
				sx: {
					borderRadius: 2,
					boxShadow: 12
				}
			}}
		>
			{error && (
				<>
					<DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1.5, pb: 1 }}>
						<Chip
							label={error.status || "HTTP"}
							color="error"
							size="small"
							sx={{ fontWeight: 700 }}
						/>
						<Box component="span" sx={{ fontWeight: 700 }}>
							{statusLabel(error.status)}
						</Box>
					</DialogTitle>

					<DialogContent sx={{ pt: 1 }}>
						<Typography variant="body2" color="text.secondary">
							The operation failed. Press OK to return to the home screen.
						</Typography>
					</DialogContent>

					<DialogActions sx={{ px: 3, pb: 2 }}>
						<Button onClick={goHome} variant="contained" color="error">
							OK
						</Button>
					</DialogActions>
				</>
			)}
		</Dialog>
	);
};